<template>
  <div class="default-modify">
    <div class="default-modify_top flex-row justify-between align-center">
      <!--前进-->
      <i
        class="operate-text iconfont icon-shangyibu cursor-pointer button-ripple"
        :style="props.btnDisabled ? 'background:#e5d6be!important' : ''"
        @click="goBackLastStep"
      ></i>
      <div class="default-modify_progress flex-row">
        <!--进度背景-->
        <img
          v-show="aiTheme === 'default'"
          class="default-modify_progress-bg"
          :src="getBrandImageUrl('ai_smart_reading/next_step_bg.png')"
          alt=""
        />
        <img
          v-show="aiTheme === 'brown'"
          class="default-modify_progress-bg"
          :src="getBrandImageUrl('ai_smart_reading/next_step_bg_brown.png')"
          alt=""
        />
        <img
          v-show="aiTheme === 'silver'"
          class="default-modify_progress-bg"
          :src="getBrandImageUrl('ai_smart_reading/next_step_bg_silver.png')"
          alt=""
        />
        <img
          v-show="aiTheme === 'dark'"
          class="default-modify_progress-bg"
          :src="getBrandImageUrl('ai_smart_reading/next_step_bg_dark.png')"
          alt=""
        />

        <!--进度条-->
        <div class="current-progress">
          <div class="current-progress_bg">
            <!--进度条 相对 进度背景 定位-->
            <img
              v-show="aiTheme === 'default'"
              class="current-progress_progress"
              :src="getBrandImageUrl('ai_smart_reading/progress_bg.png')"
              alt=""
            />
            <img
              v-show="aiTheme === 'brown'"
              class="current-progress_progress"
              :src="getBrandImageUrl('ai_smart_reading/progress_bg_brown.png')"
              alt=""
            />
            <img
              v-show="aiTheme === 'silver'"
              class="current-progress_progress"
              :src="getBrandImageUrl('ai_smart_reading/progress_bg_silver.png')"
              alt=""
            />
            <img
              v-show="aiTheme === 'dark'"
              class="current-progress_progress"
              :src="getBrandImageUrl('ai_smart_reading/progress_bg_dark.png')"
              alt=""
            />
            <!--当前进度条 相对 进度条 定位-->
            <div class="current-progress_position">
              <!-- 标注笔 相对 当前进度条 定位-->
              <div class="current-progress_position-address">
                <!-- 进度条样式 -->
                <img
                  class="current-progress_position-step transition-out step_1_width"
                  :class="{
                    step_1_width: [1].includes(currentStepStore.currentStep),
                    step_2_width: [2,5, 8].includes(currentStepStore.currentStep),
                    step_3_width: [3,6, 9].includes(currentStepStore.currentStep),
                    step_4_width: [4, 7,10].includes(currentStepStore.currentStep),
                  }"
                  :src="getBrandImageUrl('ai_smart_reading/progress_passed_step_2.png')"
                  alt=""
                />
                <!-- 标注笔样式 -->
                <img
                  class="current-progress_position-pencil transition-out pencil-left-step-1"
                  :class="{
                    'pencil-left-step-1': [1].includes(currentStepStore.currentStep),
                    'pencil-left-step-2': [2,5, 8].includes(currentStepStore.currentStep),
                    'pencil-left-step-3': [3,6, 9].includes(currentStepStore.currentStep),
                    'pencil-left-step-4': [4,7, 10].includes(currentStepStore.currentStep),
                  }"
                  :src="getBrandImageUrl('ai_smart_reading/progress_pencil.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!--进度文字-->
        <div class="current-title flex-row">
          <div
            class="current-title_bg"
            :class="{
              'bg_color_step_1 transition-out': [1].includes(currentStepStore.currentStep),
              'bg_color_step_2 transition-out': [2,5, 8].includes(currentStepStore.currentStep),
              'bg_color_step_3 transition-out': [3,6, 9].includes(currentStepStore.currentStep),
              'bg_color_step_4 transition-out': [4,7, 10].includes(currentStepStore.currentStep),
            }"
          ></div>
          <div
            v-for="step in currentStepStore?.currentStepList"
            :key="step.step"
            class="current-title_name justify-center"
            :class="{
              'current-text': currentStepStore.currentStep === step.step,
              'is-ready-class': step_ready_status[step.step - 1],
            }"
          >
            <div
              v-if="[2, 3, 5, 6, 7, 8, 9].includes(currentStepStore?.currentStep)"
              class="current-title_text cursor-pointer"
              @click="clickTitleEvent"
            >
              <span class="transition-out">{{ step.title }}</span>
            </div>
            <div v-else class="current-title_text">
              <span class="transition-out">{{ step.title }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--下一步 & 结束按钮-->
      <i
        class="operate-text iconfont icon-xiayibu cursor-pointer button-ripple"
        :style="props.btnDisabled ? 'background:#e5d6be!important' : ''"
        @click="throttledStep"
      ></i>
    </div>
    <div
      v-show="currentStepStore?.currentStep === 1 && aiReadingStatus !== 'end'"
      class="progress-bar-container"
    >
      <div class="progress-bar-container__label">正在泛读整篇文章，{{ aiReadingTime }}s</div>
      <div class="progress-bar-container__btn button-ripple" @click="finishReading">我读完了</div>
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable */

import { modalController } from "@ionic/vue";
import { defineEmits, defineProps, onBeforeUnmount, ref, watch } from "vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useExerciseCountdownStore } from "@/hooks/useExerciseCountdown";
import { useCurrentStepStore } from "@/hooks/useCurrentStepStore";
import { useRoute } from "vue-router";
import { useStorage, useThrottleFn } from "@vueuse/core";
import PageDialog from "@/components/PageDialog.vue";
import { getBrandImageUrl } from "@/js/brandImages";
import { default_step_title } from "@/views/AIGenerate/smartReading/defaultData";
import ArticleEndModal from "@/views/reading/newReadingArticle/ArticleEndModal.vue";

const props = defineProps(["modalIsFold", "exerciseObj", "btnDisabled", "readingId", "wordCount","fromAdmin"]);
const emit = defineEmits([
  "getCurrentStep",
  "closeCurrentHalfModal",
  "clickProgressTitle",
  "openCurrentHalfPage",
  "hideAllAudioIcon",
  "pauseAudioPlayer",
])
const countdownStore = useExerciseCountdownStore()
const currentStepStore = useCurrentStepStore()
const route = useRoute()
const aiTheme = useStorage("ai-theme", "brown", localStorage)
const aiReadingTime = useStorage("aiReadingTime", 0, sessionStorage)
const aiReadingStatus = useStorage("aiReadingStatus", "", sessionStorage)
const studentInfo = ref()
const step_ready_status = ref(default_step_title.map(() => true))
const throttledStep = useThrottleFn(() => {
  if (props.btnDisabled) return
  clickNextProgressStep()
}, 500)
const btnDisabled = ref(true)
watch(
  () => props.wordCount,
  () => {
    if (!aiReadingStatus.value) {
      aiReadingTime.value = 180
      startTime()
    } else if (aiReadingStatus.value === "start") {
      startTime()
    }
  },
  { deep: true }
)

function startTime() {
  aiReadingStatus.value = "start"
  const timer = setInterval(() => {
    if (aiReadingTime.value === 0) {
      clearInterval(timer)
    } else {
      aiReadingTime.value = aiReadingTime.value - 1
    }
  }, 1000)
}

function finishReading() {
  if (props.btnDisabled) return
  aiReadingStatus.value = "end"
  clickNextProgressStep()
}

function clickTitleEvent() {
  emit("clickProgressTitle")
}

function alertModal() {
  return new Promise(async (resolve) => {
    const modal = await modalController.create({
      id: "PageDialog",
      component: PageDialog,
      componentProps: {
        title: "提示信息",
        message: "是否回退？",
        type: "hasCancel",
      },
      cssClass: "center_modal_controller_class3",
    })

    modal.onDidDismiss().then((res) => {
      if (res.data === "NEXT") {
        resolve("ENSURE")
      } else {
        resolve("CANCEL")
      }
    })
    return modal.present()
  })
}

// 上一步
function goBackLastStep() {
  if (props.btnDisabled) return
  if (currentStepStore.currentStep === 1) {
    return
  }

  alertModal().then((data) => {
    if (data === "ENSURE") {
      if (currentStepStore.currentStep === 4 || currentStepStore.currentStep === 5) {
        clearSentenceStyle()
        emit("pauseAudioPlayer")
      }
      currentStepStore.goBackLastStep(closeCurrentHalfModal, openCurrentHalfPage)
    }
  })
}

function createSentenceNode(cn: string) {
  const cnDom = document.createElement("span")
  cnDom.className = "ai-sentence-paraphrase"
  cnDom.style.display = "none"
  cnDom.style.color = "#97989C"
  // const cn = translateArr[idx]?.sentenceWithParaphraseCn || ''
  cnDom.innerHTML = cn.replaceAll("**", "")
  return cnDom
}

function clearSentenceStyle() {
  if (currentStepStore.currentStep === 4) {
    const article = document.querySelectorAll(".ai-article-sentence")
    if (article) {
      article.forEach((el: any) => {
        el.style.backgroundColor = "transparent"
        el.style.color = "#606266"
      })
    }
    const paragraphArr = document.querySelectorAll(".ai-sentence-paraphrase")
    const analysisIcon = document.querySelectorAll(".analysis-icon")

    if (paragraphArr) {
      paragraphArr.forEach((el: any) => {
        // el.classList.add('sentence-paraphrase-hidden')
        el.style.display = "none"
      })
    }
    if (analysisIcon) {
      analysisIcon.forEach((el: any) => {
        el.classList.add("sentence-paraphrase-hidden")
      })
    }
  }
  if (currentStepStore.currentStep === 5) {
    hiddenAllParagraphStyle()
  }
  emit("hideAllAudioIcon")
}

function hiddenAllParagraphStyle() {
  const paragraphDomArr = document.querySelectorAll(".ai-article-paragraph")
  if (paragraphDomArr) {
    paragraphDomArr.forEach((el: any) => {
      el.classList.remove("ai-article-highlight")
      const audioIconDom = el.querySelector("#ai-sentence-audio")
      const essayIconDom = el.querySelector(".essay-icon")
      audioIconDom.classList.add("sentence-paraphrase-hidden")
      essayIconDom.classList.add("sentence-paraphrase-hidden")
    })
  }
}

let timer: any = null
let flag

async function clickNextProgressStep() {
  const exeObj = props.exerciseObj
  //如果5道题全部有答案，则继续下一步
  if (!countdownStore.countdownEnds) {
    if (2 === currentStepStore.currentStep && !exeObj.answer) {
      await openMsgToast("你还未提交测试答案")
      return
    }
  }

  if (currentStepStore.currentStep === 4 || currentStepStore.currentStep === 5) {
    clearSentenceStyle()
  }
  emit("pauseAudioPlayer")
  // 根据相关流程的内容是否生成完毕，放开该流程的使用功能
  await handleProgressEvent()
  // await openStartExerciseModal() // 开始测试
}

// 操作下一步 | 上一步内容
async function handleProgressEvent() {
  currentStepStore.controlStepData() // 处理流程执行数据
  currentStepStore.handleProgressTitleNameArr() // 动态展示流程名称
  await currentStepStore.handleProgressStepEvent(closeCurrentHalfModal, openCurrentHalfPage) // 处理每个流程相关的事件

  if (currentStepStore.processIsEnd && !props.fromAdmin) {
    await currentStepStore.handleEndOfProcessEvent(openEndNotifyModal, closeCurrentHalfModal) // 流程结束
  }
}

function closeCurrentHalfModal() {
  emit("closeCurrentHalfModal")
}

async function openCurrentHalfPage() {
  // 2-泛读答题 & 6-全文大意 & 9-知识点
  if ([2, 6, 9].includes(currentStepStore.currentStep)) {
    const exeObj = props.exerciseObj
    switch (currentStepStore.currentStep) {
      case 2: // 泛读答题
        emit("openCurrentHalfPage")
        break
      case 6: // 全文大意
        emit("openCurrentHalfPage")
        break
      case 9: // 知识点
        emit("openCurrentHalfPage")
        break
      default:
        break
    }
    return
  }
  emit("openCurrentHalfPage")
}

// 已完成流程最后一步环节，结算弹窗
async function openEndNotifyModal() {
  if (currentStepStore.processIsEnd) {
    const modal = await modalController.create({
      component: ArticleEndModal,
      componentProps: { readingId: props.readingId, fromPrepareOrigin: props.fromPrepareOrigin },
      showBackdrop: false,
      cssClass: "center_modal_controller_class",
    })
    await modal.present()
    modal.onDidDismiss().then(({ data }) => {
      if (data.type === "TEXT") {
        modalController.dismiss("FINISHED").catch((e) => console.log(e))
      }
    })
  }
}

onBeforeUnmount(() => {})
</script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/theme/ai-theme.less";

.default-modify {
  width: calc(100% - 0.25rem);
  height: 10vw;
  position: relative;

  &_top {
    width: 100%;
    height: 100%;

    .operate-button {
      height: 100%;
    }

    .operate-text {
      padding: 0.5rem;
      font-size: 1.5rem;
      border-radius: 11px;
      color: #ffffff;
      background-color: var(--progress-button-bg);
    }

    .right-buttons {
      height: 100%;
      position: relative;

      .fold-expand {
        position: absolute;
        bottom: calc(100% + 1vw);
        right: 0;
        height: 100%;
      }
    }
  }

  &_progress {
    position: relative;
    flex: 0.9;
    width: 100%;
    height: 100%;

    .trumpet-emoji {
      position: absolute;
      bottom: 100%;
      left: 5%;
      width: 100%;

      &_left {
        width: 40%;
      }

      &_nice {
        width: 46%;
      }
    }

    .fireworks-emoji {
      position: absolute;
      bottom: 150%;
      left: 50%;
      width: 100%;

      .fireworks-image {
        width: 65%;
      }

      .applaud-image {
        width: 50%;
      }
    }

    .current-progress {
      position: absolute;
      top: 30%;
      left: 0;
      width: 100%;
      display: flex;
      z-index: 2;

      &_bg {
        position: relative;
        display: flex;
        width: 100%;
      }

      &_progress {
        width: 100%;
      }

      // 进度 & 标注笔位置
      &_position {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;

        &-address {
          position: relative;
          display: flex;
          width: 100%;
        }

        &-pencil {
          position: absolute;
          bottom: 0;
          transition: all 0.3s ease-in;
          height: 100%;
        }

        &-step {
          transition: all 0.3s ease-in;
        }
      }

      .step_1_width {
        width: 8%;
      }

      .pencil-left-step-1 {
        left: 7%;
      }

      .step_2_width {
        width: 24%;
      }

      .pencil-left-step-2 {
        left: 23%;
      }

      .step_3_width {
        width: 51%;
      }

      .pencil-left-step-3 {
        left: 50%;
      }

      .step_4_width {
        width: 69%;
      }

      .pencil-left-step-4 {
        left: 68%;
      }

      .step_5_width {
        width: 90%;
      }

      .pencil-left-step-5 {
        left: 89%;
      }

      .step_6_width {
        width: 92%;
      }

      .pencil-left-step-6 {
        left: 91%;
      }
    }

    .current-title {
      position: absolute;
      bottom: 15%;
      left: 0;
      width: 100%;
      z-index: 4;
      display: flex;

      &_name {
        display: inline-block;
        width: 20%;
        text-align: center;
        font-size: 2vw;
        color: var(--text-disabled-color, #868f9e);
        z-index: 5;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          right: 0.3rem;
          top: -0.1rem;
          width: 0.3rem;
          height: 0.3rem;
          background: var(--text-disabled-color);
          border-radius: 50%;
        }
      }

      &_text {
        display: flex;

        span {
          display: inline-block;
          width: 100%;
          text-align: center;
          font-size: var(--font-2-point-zero);
        }
      }

      &_bg {
        position: absolute;
        bottom: -5%;
        left: 10%;
        width: 16%;
        height: 110%;
        background-color: var(--button-background-color, #ff5323);
        border-radius: 0.5vw;
        z-index: 4;
        transition: all 0.3s ease-in;
      }

      .bg_color_step_1 {
        left: 1%;
      }

      .bg_color_step_2 {
        left: 22%;
      }

      .bg_color_step_3 {
        left: 42%;
      }

      .bg_color_step_4 {
        left: 62%;
      }

      .bg_color_step_5 {
        left: 82%;
      }

      .bg_color_step_6 {
        left: 83%;
      }

      .current-text {
        color: #ffffff;
      }

      .is-ready-class {
        position: relative;

        &::after {
          content: "";
          position: absolute;
          right: 0.3rem;
          top: -0.1rem;
          width: 0.3rem;
          height: 0.3rem;
          background: #0bbb7d;
          border-radius: 50%;
        }
      }
    }

    &-bg {
      width: 100%;
      z-index: 1;
    }

    &-button {
      height: 100%;
    }
  }
}

.progress-bar-container {
  position: absolute;
  bottom: 0;
  height: 100%;
  left: 0;
  width: 100%;
  border-radius: 2vw;
  background: #4b4d4f;
  z-index: 20;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4vw;
  font-size: 0.8rem;

  &__btn {
    background: var(--text-import-color);
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    cursor: pointer;
    font-size: 0.7rem;
  }
}
</style>
